import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { TenantScheduleComponent } from './tenant-schedule.component';
import { TenantCreateScheduleComponent } from './tenant-create-schedule/tenant-create-schedule.component';
import { ExternalTenantGuard } from 'src/app/services/util/external-tenant.guard';

const routes: Routes = [
  {
    path: '',
    component: TenantScheduleComponent,
    title: 'Tenant Schedule',
    canActivate: [ExternalTenantGuard]
  },
  {
    path: 'create',
    component: TenantCreateScheduleComponent,
    canActivate: [ExternalTenantGuard]
  },
  {
    path: 'create/type',
    component: TenantCreateScheduleComponent,
    canActivate: [ExternalTenantGuard]
  },
  {
    path: ':scheduleId/update',
    component: TenantCreateScheduleComponent,
    canActivate: [ExternalTenantGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantScheduleRoutingModule {
}
